import { z } from 'zod';

export const FormSchema = z.object({
  ma_mau_so: z.string().min(1, 'Mã mẫu số không được để trống'),
  ten_mau_so: z.string().min(1, 'Tên mẫu số không được để trống'),
  ten_mau_so2: z.string().optional().nullable(),
  hddt_yn: z.boolean().optional().default(false),
  status: z.string().default('1')
});

export type FormValues = z.infer<typeof FormSchema>;

export const initialFormValues: FormValues = {
  ma_mau_so: '',
  ten_mau_so: '',
  ten_mau_so2: '',
  hddt_yn: false,
  status: '1'
};
